import React from 'react';

const ImagePatternIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <rect width="20" height="20" fill="url(#pattern0_231_6191)" />
    <defs>
      <pattern
        id="pattern0_231_6191"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_231_6191" transform="scale(0.0416667)" />
      </pattern>
      <image
        id="image0_231_6191"
        width="24"
        height="24"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA6UlEQVR4nO2UPQ7CMAyFPRTOEcPGygZDz0IvwUgnfgRcCsRRylBWu2tQUiGFNklTaKUi8SQv1Rc/x68KwF+tNJNjQD4A8h2QMhC8099cmssRCDqD4IfmkfdeXgPI8q0Eb5284FONVz3cBnoKCdNiAZNiWR6gzBhANpfBWybKNaSavwwE590Z2FaEnivbVqRycyqWkQZMOJaRN2TkY3nzkJCrq+hNgzPAtgP1btBWOBgDQbf6f03Xhuapwadhk1QrrHnIW9TCACnxPBdJvwYTWn1voCRobclsA06pQOsHLt2F/KmQEvdafl1P8A9GvJwQ/VwAAAAASUVORK5CYII="
      />
    </defs>
  </svg>
);

export default ImagePatternIcon;
